import { IHomeResponse } from '../../../../model/apm/home/response/home-response';
import { IHomeSectionResponse } from '../../../../model/apm/home/response/home-section-response';
import { IHomeSectionItemResponse } from '../../../../model/apm/home/response/home-section-item-response';

export type HomeState = {
    home?: IHomeResponse;
    sections: IHomeSectionResponse[];
    loading: boolean;
    sectionDrawer: { open: boolean; section?: IHomeSectionResponse };
    itemDrawer: { open: boolean; section?: IHomeSectionResponse; item?: IHomeSectionItemResponse };
};

export enum ACTION_TYPES {
    setHome = 'setHome',
    setLoading = 'setLoading',
    setSections = 'setSections',
    setSectionItems = 'setSectionItems',
    openSectionDrawer = 'openSectionDrawer',
    closeSectionDrawer = 'closeSectionDrawer',
    openItemDrawer = 'openItemDrawer',
    closeItemDrawer = 'closeItemDrawer',
}

export const HomeReducer = (state: HomeState, action: any): HomeState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setHome:
            return { ...state, home: payload, sections: payload?.sections || [] };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setSections:
            return { ...state, sections: payload };
        case ACTION_TYPES.setSectionItems:
            return {
                ...state,
                sections: state.sections.map((s) => (s.id === payload.sectionId ? { ...s, items: payload.items } : s)),
            };
        case ACTION_TYPES.openSectionDrawer:
            return { ...state, sectionDrawer: { open: true, section: payload } };
        case ACTION_TYPES.closeSectionDrawer:
            return { ...state, sectionDrawer: { open: false } };
        case ACTION_TYPES.openItemDrawer:
            return { ...state, itemDrawer: { open: true, section: payload.section, item: payload.item } };
        case ACTION_TYPES.closeItemDrawer:
            return { ...state, itemDrawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
